// test749
(749 && 0);
